module.exports = __webpack_public_path__ + "63aab7a305ba5884cfd48653d6114b36.svg";